"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.graphql = graphql;
/* eslint-disable */
const types = __importStar(require("./graphql"));
const documents = {
    "\n      mutation CreateOrder($input: CreateOrderInput!) {\n        orders {\n          create(input: $input) {\n            id\n          }\n        }\n      }\n    ": types.CreateOrderDocument,
    "\n  query GetMetaByOrderId($orderId: ID!) {\n    orders {\n      get(id: $orderId) {\n        meta {\n          key\n          value\n        }\n      }\n    }\n  }\n": types.GetMetaByOrderIdDocument,
    "\n  query GetOrdersByCustomerId($customerId: String!) {\n    orders {\n      getAll(customerIdentifier: $customerId) {\n        edges {\n          node {\n            id\n            reference\n            createdAt\n            cart {\n              ...Cart\n            }\n            total {\n              net\n              gross\n            }\n            meta {\n              key\n              value\n            }\n          }\n        }\n      }\n    }\n  }\n\n  fragment Cart on OrderItem {\n    price {\n      net\n      gross\n    }\n    imageUrl\n    sku\n    name\n    quantity\n    subTotal {\n      net\n      gross\n    }\n    meta {\n      key\n      value\n    }\n  }\n": types.GetOrdersByCustomerIdDocument,
};
function graphql(source) {
    return documents[source] ?? {};
}
